import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "./Icon";

const ExpandToggleButton = ({
  textCollapsed = "Expand",
  textExpanded = "Collapse",
  onClick
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleIt = () => {
    setExpanded(!expanded);
    onClick();
  };

  const text = expanded ? textExpanded : textCollapsed;
  const iconName = expanded ? "chevron-up" : "chevron-down";

  return (
    <span
      className={`
        expand-toggle-button
        ${
          expanded
            ? "expand-toggle-button--expanded"
            : "expand-toggle-button--collapsed"
        }
      `}
      onClick={toggleIt}
    >
      <Icon name={iconName} className="expand-toggle-button__icon" />
      <span className="expand-toggle-button__text">{text}</span>
    </span>
  );
};

ExpandToggleButton.propTypes = {
  textCollapsed: PropTypes.string,
  textExpanded: PropTypes.string,
  onClick: PropTypes.func
};

export default ExpandToggleButton;
